var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"free-episode",attrs:{"data-test":"free-episode-indicator"}},[_vm._v("\n  LISTEN FREE\n")])}
var staticRenderFns = []

export { render, staticRenderFns }